import get from 'lodash/get';
import reject from 'lodash/reject';

export function removeEdgeById(edges: any[], id: string): any[] {
  return reject(edges, edge => get(edge, 'node.id') === id);
}
